import { useTranslation } from 'react-i18next';

export const ChatMessageButton = ({ onClick, disabled }: { onClick: () => void; disabled: boolean }) => {
    const { t } = useTranslation();

    return (
        <button
            type="button"
            data-testid="chatMsgSendBtn"
            onClick={onClick}
            disabled={disabled}
            className="group w-14 flex items-center justify-center bg-white not-disabled:hover:bg-primary [&:not(:disabled):hover>svg]:fill-on-primary rounded-r-lg border-y-2 border-r-2 border-primary transition-colors ease-in-out duration-200"
        >
            <span className="sr-only">{t('Player.Chat.Send')}</span>
            <svg
                className={`w-10 h-10 bg-transparent inline-block fill-primary transition-colors ease-in-out duration-200 ${disabled ? 'opacity-50' : ''}`}
                data-name="icon-send"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 38 38"
                aria-hidden="true"
            >
                <path d="M3.9,22.06l9.27,2.34,1.55,9.66L19.46,26l8.32,2.1,3-22.67Zm3.79-.59L26.13,10,13.86,23Zm6.89,2.26,12.55-13.3-8.4,13.82-3.2,5.45Zm11.93,2.48-6.77-1.7,8.91-14.7Z" />
            </svg>
        </button>
    );
};
